import { gridSizeMdLg12, gridSizeMdLg6 } from "@/shared";
import { CustomTextField, CustomTextFieldNoForm } from "@/shared/components/ui";
import { Grid } from "@mui/material";
export type ClienteFormComponetVisitaProps = {
    form: any
}
export default function ClienteFormComponetVisita({ form }: ClienteFormComponetVisitaProps) {
    const { errors } = form.formState;
    console.log('form', form.getValues())
    return (
        <Grid container spacing={2} justifyItems={"center"} mt={1}>
            <CustomTextField
                label="Nombre"
                name="prospecto_data.razon_social"
                control={form.control}
                defaultValue={form.getValues()?.prospecto_data?.razon_social || ""}
                error={errors?.prospecto_data?.razon_social}
                helperText={errors?.prospecto_data?.razon_social?.message?.toString() ?? ""}
                shrink={true}
                size={gridSizeMdLg12}
                disabled
            />
            <CustomTextField
                label="No. ID"
                name="prospecto_data.identificacion"
                control={form.control}
                defaultValue={form.getValues()?.prospecto_data?.identificacion || ""}
                error={errors?.prospecto_data?.identificacion}
                helperText={errors?.prospecto_data?.identificacion?.message?.toString() ?? ""}
                shrink={true}
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextField
                label="Número de Contrato"
                name={"linea"}
                control={form.control}
                defaultValue={form.getValues().prospecto_data?.linea || ""}
                error={errors.linea}
                helperText={errors.linea?.message}
                shrink={true}
                size={gridSizeMdLg6}
                disabled
            />
            <CustomTextFieldNoForm
                label="Plan"
                value={form.getValues()?.plan_data?.nombre || "Plan no registrado"}
                size={gridSizeMdLg6}
                disabled
            />
        </Grid>
    )
}
